import React, { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { useSelector } from "react-redux";
import { State } from "./store";
import useBasketManager from "./components/FinalizePage/hooks/useBasketManager";
import ShopNotWorking from "../features/Alerts/ShopNotWorking";
import useFacility from "../utils/hooks/useFacility";
import Smartsupp from "./components/Smartsupp";
import useClearStorageAndCache from "../utils/hooks/useClearStorageAndCache";
import useMyAccount from "./components/MyAccount/hooks/useMyAccount";
import useSuccessRedirection from "../utils/hooks/useSuccessRedirection";
import NavBar from "../features/NavBar";
import RoutesComponent from "./components/Routes";
import "./MainApp.scss";
import useDesktopSize from "../utils/hooks/useDesktopSize";
import Footer from "../features/Footer";
import useShowNavBar from "../features/NavBar/hooks/useShowNavBar";
import AlertsHandler from "../features/Alerts";
import EAFullScreenLoader from "./components/shared/EAFullScreenLoader";

const MainApp: React.FC = () => {
  const { configuration, loading: configLoading } = useSelector((state: State) => state.config);
  const { getBasket } = useBasketManager();
  const facilityIds = useFacility();
  const isDesktop = useDesktopSize();
  const showNavBar = useShowNavBar();
  const [loading, setLoading] = useState(true);
  useMyAccount();
  useSuccessRedirection();
  useClearStorageAndCache();

  useEffect(() => {
    if (!configLoading && configuration && Object.keys(configuration).length > 0) {
      setLoading(false);
    }
  }, [configLoading, configuration]);

  useEffect(() => {
    setTimeout(() => {
      getBasket();
    }, 200);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [facilityIds]);

  useEffect(() => {
    const localStorageLng = localStorage.getItem("i18nextLng");
    if (!localStorageLng) {
      localStorage.setItem("i18nextLng", "PL");
    }
  }, []);

  if (loading) {
    return <EAFullScreenLoader />;
  }

  if (configuration.saleActive) {
    return (
      <div className="flex-center-center">
        <ShopNotWorking title={configuration.saleInActiveTitle} message={configuration.saleInActiveMessage} />
      </div>
    );
  } else {
    return (
      <BrowserRouter>
        {configuration.chatOnline && <Smartsupp />}
        <div className="app">
          <NavBar layout={configuration.widgetActive ? "horizontal" : "vertical"} />
          <main
            className={`
              ${configuration.widgetActive || !isDesktop ? "horizontal" : "vertical"} ${
              !showNavBar ? "no-margin" : ""
            }`}
          >
            <RoutesComponent />
            <Footer />
          </main>
        </div>
        <AlertsHandler />
      </BrowserRouter>
    );
  }
};

export default MainApp;
